const config = {
  local: {
    serviceName: "odin-ui",
    baseMagentoApiUrl: "https://ecommerce-sales-show.rxweb-pre.com",
    baseApiUrl: "https://reedexpopreprod-dev.apigee.net/v2",
    registrationApiUrl: "https://registration-dev.rxweb-dev.com",
    timeoutBeforeLogoutInMinutes: 30
  },
  localAgainstDev: {
    serviceName: "odin-ui",
    baseMagentoApiUrl: "https://ecommerce-sales-show.rxweb-pre.com",
    registrationApiUrl: "https://registration-dev.rxweb-dev.com",
    timeoutBeforeLogoutInMinutes: 30
  },
  dev: {
    serviceName: "odin-ui",
    serviceVersion: "1.0",
    baseMagentoApiUrl: "https://ecommerce-sales-show.rxweb-pre.com",
    baseApiUrl: "https://reedexpopreprod-dev.apigee.net/v2",
    registrationApiUrl: "https://registration-dev.rxweb-dev.com",
    timeoutBeforeLogoutInMinutes: 30
  },
  localAgainstShow: {
    serviceName: "odin-ui",
    serviceVersion: "1.0",
    baseMagentoApiUrl: "https://show.ecommerce.rxweb-pre.com",
    baseApiUrl: "https://reedexpopreprod-demo.apigee.net/v2",
    registrationApiUrl: "https://registration-show.rxweb-pre.com",
    timeoutBeforeLogoutInMinutes: 30
  },
  show: {
    serviceName: "odin-ui",
    serviceVersion: "1.0",
    baseMagentoApiUrl: "https://show.ecommerce.rxweb-pre.com",
    baseApiUrl: "https://reedexpopreprod-demo.apigee.net/v2",
    registrationApiUrl: "https://registration-show.rxweb-pre.com",
    timeoutBeforeLogoutInMinutes: 30
  },
  preprod: {
    serviceName: "odin-ui",
    serviceVersion: "1.0",
    baseMagentoApiUrl: "https://preprod.ecommerce.rxweb-pre.com",
    baseApiUrl: "https://api.rxweb-pre.com/v2",
    registrationApiUrl: "https://registration-preprod.rxweb-pre.com",
    timeoutBeforeLogoutInMinutes: 30
  },
  prod: {
    serviceName: "odin-ui",
    serviceVersion: "1.0",
    baseMagentoApiUrl: "https://prod.ecommerce.rxweb-prd.com",
    baseApiUrl: "https://api.reedexpo.com/v2",
    registrationApiUrl: "https://registration.rxglobal.com",
    timeoutBeforeLogoutInMinutes: 30
  }
};

// @ts-ignore
const getConfig = env => (env && config[env] ? config[env] : null);

const mainConfig = {
  getConfig,
  config
};

export default mainConfig;
